<template>
    <div v-if="items.length > 0">
        <div class="related-items has-color-initial has-background-primary padding-4 rounded-border">
        <h3 class="has-text-center">{{ relatedInfo.title }}</h3>
        <div class="container">
            <div class="row">
                <div class="column column-25" v-for="item in items" v-bind:key="item.id" style="text-align: center;">
                    <router-link :to="{ name: item.id }" class="has-color-intial">
                        <img v-if="item.thumbnail" :src="item.thumbnail.url">
                        <p>{{ item.title }}
                            <br>
                            {{ showOverlapNodes(item.node_data) }}
                            <span v-if='item.page_type=="eventpage"'>
                                <br>
                                {{ item.event_date }}
                            </span>
                            </p>
                    </router-link>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default{
    name: 'relateditems',
    data() {
        return {
            'items': [],
            'error': false,
        }
    },
    props: {
        relatedInfo: {
            type: Object,
            required: true
        },
        pageNodes: {
            type: Array,
            required: true
        },
    },
    watch:{
        pageNodes: function(val){
            this.setItems()
        }
    },
    computed: {
        // Get the nodes of the parent that are the decendants of the overlap node
        overlapNodes: function() {
            var overlap_node = this.relatedInfo.overlap_node
            return this.getChildrenOfNodeFromPage(this.pageNodes, overlap_node)
        }, 
    },
    mounted() {
        this.setItems()
    },
    methods: {
        setItems: function() {
            var nodeIds = ''
            for (var node in this.overlapNodes){
                nodeIds += 'overlapNodes='+this.overlapNodes[node].id + '&'
            }
            if (this.relatedInfo.events_only) {
                let getString = ''
                if (this.relatedInfo.nodes_to_find) {
                    getString = '/api/get_related_events/?'+nodeIds+'nodesToFind='+this.relatedInfo.nodes_to_find.id;
                } else {
                    nodeIds = nodeIds.slice(0, -1)
                    getString = '/api/get_related_events/?'+nodeIds
                }
                console.log("API call string: "+ getString);
                axios
                .get(getString)
                .then((response) => {
                    this.items = response.data
                })
                .catch(error => (this.error = error));
            } else {
                axios
                .get('/api/get_related_items/?'+nodeIds+'nodesToFind='+this.relatedInfo.nodes_to_find.id)
                .then((response) => {
                    this.items = response.data
                })
                .catch(error => (this.error = error));
            }
        },
        getChildrenOfNodeFromPage: function(pageNodes, parentNode) {
            return pageNodes.filter(node => {
                return node.path.startsWith(parentNode.path) && node.path !== parentNode.path
            })
        },
        getNodeNames: function(nodes) {
            var names = []
            for (var node in nodes) {
                names.push(nodes[node].name)
            }
            return names
        },
        showOverlapNodes: function(nodes) {
            return this.getNodeNames(this.getChildrenOfNodeFromPage(nodes, this.relatedInfo.overlap_node)).join(', ');
        }
    }
}
</script>